import type { ReactNode } from 'react';

/** Every list gets one, with a single primary action (design hand-off §6). `note` is for the cases
 *  where the honest thing is to explain an ABSENCE — segments has no audience-size preview, and
 *  experiences cannot be authored until the builder lands in P3.3. */
export function EmptyState({
  title,
  description,
  action,
  note,
}: {
  title: string;
  description: string;
  action?: ReactNode;
  note?: string;
}): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed px-6 py-16 text-center">
      <h3 className="text-sm font-medium">{title}</h3>
      <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p>
      {action && <div className="mt-4">{action}</div>}
      {note && <p className="mt-6 max-w-md text-xs text-muted-foreground/80">{note}</p>}
    </div>
  );
}
